module.exports = ->
  config = Groupon?.Utils?.getConfigFromDom()

  return unless config?.pageLoadData
  return unless BOOMR?.getVar

  t_resp = BOOMR.getVar('t_resp')
  t_page = BOOMR.getVar('t_page')
  t_done = BOOMR.getVar('t_done')

  variants = config.pageLoadData.experiments
  deal_data = config.pageLoadData.dealData
  t_page_presenter = config.pageLoadData.pagePresenterTime
  t_api = config.pageLoadData.apiTime
  body_size = BOOMR.getVar('body_size')

  OptimizeSuite.TrackingHub.add 'deal_page_experiment_performance', {
    deal_data,
    t_page,
    t_done,
    t_resp,
    t_page_presenter,
    t_api,
    body_size,
    variants
  }
